module.exports = __webpack_public_path__ + "img/占位.271bdc78.jpg";